module.exports = __webpack_public_path__ + "1799f975723963c35e82ef1b2e607806.png";